<template>
   <div class="form-wrapper">
		<div class="w-full" v-if="step === 1">
		<h3>{{ $t('shirtigo.login.register_title') }}</h3>
		<div class="spacer-small"></div>
		<p class="form-content"><span v-html="$t('shirtigo.login.register_now_free_headline')"></span> <a href="https://cockpit.shirtigo.com/de#disclaimer">{{ $t('shirtigo.login.more_info') }}</a></p>

		<div class="spacer-medium"></div>

		<social-login-btn provider="google">
			{{ $t('shirtigo.login.social_btn.google') }}
		</social-login-btn>

		<div class="spacer-small"></div>

		<social-login-btn provider="facebook">
			{{ $t('shirtigo.login.social_btn.facebook') }}
		</social-login-btn>

		<div class="separator"><span>{{ $t('shirtigo.login.separator') }}</span></div>

		<div>
			<sg-btn
				kind="primary"
				class="btn-fullwidth"
				:loading="isLoading"
				@click="step = 2">
				{{ $t('shirtigo.login.cta_register1') }}
			</sg-btn>
		</div>

		<div class="spacer-medium"></div>

		<p class="login-text">{{ $t('shirtigo.login.link_to_login.label') }}
			<a :href="buildUrl('/login')">
			{{ $t('shirtigo.login.link_to_login.action') }}
			<svg xmlns="http://www.w3.org/2000/svg" id="V2" viewBox="0 0 24 24" width="16px" height="16px"><path fill="currentColor" d="m20.92,12.38c.1-.24.1-.52,0-.76-.05-.12-.12-.23-.22-.33l-7-7c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l5.29,5.29H4c-.55,0-1,.45-1,1s.45,1,1,1h13.59l-5.29,5.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l7-7c.09-.09.17-.2.22-.33Z"></path></svg>
			</a>
		</p>

		<div class="spacer-regular"></div>

		<small class="disclaimer">
			{{ $t('shirtigo.login.footer_legal_text') }}
		</small>
		</div>

		<div v-else class="w-full">
		<div class="form-wrapper-inner">
			<div class="form-content-new-1">
				<a class="back" @click="step = 1">
					<svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-small"><path d="M17,11H9.41l3.3-3.29a1,1,0,1,0-1.42-1.42l-5,5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76,1,1,0,0,0,.21.33l5,5a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L9.41,13H17a1,1,0,0,0,0-2Z" fill="currentColor"></path></svg>
					{{ $t('shirtigo.login.back') }}
				</a>
				<div class="spacer-xsmall"></div>
				<h3>{{ $t('shirtigo.login.register_title_step2') }}</h3>
				<div class="spacer-medium"></div>
				<form class="login-form" @submit.prevent="submitForm">

					<form-group :has-danger="errors && errors.name">
						<float-label-input
							type="text"
							class-name="login-form__input input-lg"
							:title="$t('shirtigo.login.name_input')"
							:placeholder="''"
							:value="name"
							:has-danger="errors && errors.name|| Boolean(formError.name)"
							required
							@input="$emit('input:name', $event)"
							:error-message="formError.name"
						/>
					</form-group>

					<form-group :has-danger="errors && errors.email">
						<float-label-input
							type="email"
							class-name="login-form__input input-lg"
							:title="$t('shirtigo.login.email_input_label')"
							:placeholder="''"
							:value="email"
							:has-danger="errors && errors.email || Boolean(formError.email)"
							autocomplete="email"
							:autofocus="false"
							required
							@input="$emit('input:email', $event)"
							:error-message="formError.email"
						/>
					</form-group>

					<form-group :has-danger="errors && errors.password">
						<password-input
							class-name="login-form__input input-lg"
							:title="$t('shirtigo.login.password_input_label')"
							:value="localPassword"
							:has-danger="errors && errors.password || Boolean(formError.password)"
							required
							@input="onPasswordInput"
							@keydown.enter="submitForm"
							:error-message="formError.password"
						/>
						<div class="form_password-strength">
							<div class="form_password-strength-indicator">
								<div
									class="form_password-strength_line"
									:class="strengthColor"
								></div>
							</div>
							<div class="form_password-strength-label">
								<div class="text-size-xsmall">{{ $t('shirtigo.auth.password_strength') }}:</div>
								<div class="text-size-xsmall text-weight-semibold">
									{{ strengthLabel }}
								</div>
							</div>
						</div>
					</form-group>

					<div>
						<sg-btn
							kind="primary"
							type="submit"
							class="btn-fullwidth"
							:loading="isLoading">
							{{ $t('shirtigo.login.register_free_cta') }}
						</sg-btn>
					</div>
				</form>
			</div>
		</div>

		<div class="spacer-regular"></div>

		<p class="terms">
			Durch deine Registrierung erklärst du dich mit unseren <a href="#">AGB</a>, den <a href="#">Informationen zum Widerrufsrecht</a> sowie den <a href="#">Hinweisen zum Datenschutz</a> und den Datenrichtlinien einverstanden.
		</p>

		<div class="spacer-medium"></div>

		<p class="login-text">{{ $t('shirtigo.login.link_to_login.label') }}
			<a :href="buildUrl('/login')">
			{{ $t('shirtigo.login.link_to_login.action') }}
			<svg xmlns="http://www.w3.org/2000/svg" id="V2" viewBox="0 0 24 24" width="16px" height="16px"><path fill="currentColor" d="m20.92,12.38c.1-.24.1-.52,0-.76-.05-.12-.12-.23-.22-.33l-7-7c-.39-.39-1.02-.39-1.41,0s-.39,1.02,0,1.41l5.29,5.29H4c-.55,0-1,.45-1,1s.45,1,1,1h13.59l-5.29,5.29c-.39.39-.39,1.02,0,1.41.2.2.45.29.71.29s.51-.1.71-.29l7-7c.09-.09.17-.2.22-.33Z"></path></svg>
			</a>
		</p>
		</div>
	</div>
</template>

<script>
  import SgBtn from 'sb/elements/Buttons/SgBtn.vue'
  import SocialLoginBtn from 'sb/elements/Buttons/SocialLoginBtn.vue'
  import FloatLabelInput from 'sb/elements/Form/FloatLabelInput.vue'
  import FormGroup from 'sb/elements/Form/FormGroup.vue'
  import PasswordInput from './PasswordInput.vue'

  export default {

    props: {
      formError: {
        type: [Object, String],
        default: () => ({}),
      },
			name: String,
      email: String,
      password: String,
      hasUserAccount: {
        type: Boolean,
        default: true
      },
      successMessage: String
    },

    data() {
      return {
        isLoading: false,
        showPassword: false,
        errors: {},
		step: 1,
		show: false,
		strengthLevel: 0,
		localPassword: this.password,
      }
    },

    methods: {
		onPasswordInput(value) {
			this.localPassword = value;
			this.evaluateStrength(value);
			this.$emit('input:password', value);
		},


	evaluateStrength() {
		const password = this.password;
		const length = password.length;

		let score = 0;

		if (length === 0) {
			this.strengthLevel = 0;
			return;
		}

		// Check for presence of different character types
		const hasLower = /[a-z]/.test(password);
		const hasUpper = /[A-Z]/.test(password);
		const hasNumber = /[0-9]/.test(password);
		const hasSymbol = /[^A-Za-z0-9]/.test(password);

		// Add points for each type
		if (hasLower) score++;
		if (hasUpper) score++;
		if (hasNumber) score++;
		if (hasSymbol) score++;

		// Add points based on length
		if (length >= 8) score++;
		if (length >= 12) score++;

		// Normalize to strength level (0–4)
		if (score <= 1) this.strengthLevel = 1;
		else if (score === 2) this.strengthLevel = 2;
		else if (score === 3) this.strengthLevel = 3;
		else this.strengthLevel = 4;
	},
		submitForm() {
			this.isLoading = true
			this.errors = {}

			if (this.name.length === 0) {
				this.$set(this.errors, 'name', true)
			}

			if (this.email.length === 0) {
				this.$set(this.errors, 'email', true)
			}

			if (this.password.length === 0) {
				this.$set(this.errors, 'password', true)
			}

			this.isLoading = false

			if (Object.keys(this.errors).length > 0) {
			return false
			}

			this.$emit('register')
		},
		buildUrl(path) {
			let url = new URL(path, location.origin)
			url.search = new URLSearchParams(location.search)
			return url
		}
    },

    computed: {
		hasFailed() {
			return Object.keys(this.errors).length > 0
		},
		strengthColor() {
			switch (this.strengthLevel) {
				case 1:
					return 'is-red';
				case 2:
					return 'is-yellow';
				case 3:
					return 'is-green';
				case 4:
					return 'is-green2';
				default:
					return 'is-default';
			}
		},

		strengthLabel() {
			const labels = [
				'',
				'Poor',
				'Medium',
				'Good',
				'Excellent'
			];
			return labels[this.strengthLevel];
		},

		strength() {
			return Math.min(this.password.length * 10, 100);
		},
    },

    watch: {
			hasUserAccount() {
				this.errors = {}
			},
			password(newVal) {
				this.localPassword = newVal;
				this.evaluateStrength(newVal);
			}
    },

    components: {
      SgBtn,
      SocialLoginBtn,
      FloatLabelInput,
      FormGroup,
      PasswordInput,
    },

  }
</script>

<style lang="scss">
  @import "~sb_sass/variables";
  @import "~sb_sass/mixins";

	.spacer-xsmall {
		padding-top: $spacing-xs;
	}
	.spacer-small {
		padding-top: $spacing-sm;
	}
	.spacer-regular {
		padding-top: spacing-rg;
	}
	.spacer-medium {
		padding-top: $spacing-md;
	}
	.spacer-large {
		padding-top: $spacing-lg;
	}
	.form-wrapper {
		max-width: 559px;
		width: 100%;
		margin: 5rem auto 3rem;
		height: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		.form-content-new-1 {
		width: 100%;
		}

		h3 {
		color: var($blue-100);
		font-size: 32px;
		margin-top: 0;
		margin-bottom: 0;
		font-weight: 800;
		line-height: 1.2;
		margin: 0px;
		}

		.form-content {
		color: #334155;
		font-size: 18px;
		line-height: 1.6;
		margin: 0px;
		padding: 0px;
		font-weight: 400;
			a {
			color: $blue-90;
			text-decoration: none;
			&:hover {
				color: $blue-110;
			}
			}
		}

		.separator {
		display: flex;
		align-items: center;
		gap: 8px;
		margin: 2rem 0;
		color: #64748b;
		font-size: 14px;

		span {
			margin: 0 0px;
		}

		&:before,
		&:after {
			content: "";
			flex: 1;
			height: 1px;
			background: #cbd5e1;
		}
		}

		.login-text  {
		font-size: 16px;
		color: #334155;
		font-weight: 400;
		line-height: 1.6;
		display: flex;
		align-items: center;
		gap: 8px;
		margin: 0px;
		padding: 0px;

		a {
			color: $blue-90;
			text-decoration: none;
			font-weight: 600;
			display: flex;
			align-items: center;
			gap: 4px;
			&:hover {
			color: $blue-110;
			}
		}
		}

		.terms {
		font-size: 12px;
		color: #334155;
		font-weight: 400;
		line-height: 1.6;
		margin: 0px;
		padding: 0px;

		a {
			color: $blue-90;
			text-decoration: none;
			font-weight: 400;
			&:hover {
			text-decoration: none;
			color: $blue-110;
			}
		}
		}

		.back {
		grid-column-gap: .25rem;
		color: var(--swatches--blue600);
		align-items: center;
		transition: all .15s;
		display: flex;
		margin: 0px;
		color: $blue-90 !important;
		font-weight: 600;
		line-height: 1.6;
		font-size: 16px;
		cursor: pointer;
		text-align: left;
		&:hover {
			color: $blue-110;
		}
		.icon-small {
			width: 24px;
			height: 24px;
			flex: none;
			justify-content: center;
			align-items: center;
			display: flex;
		}
		} 

		.disclaimer {
		font-size: 12px;
		color: #334155;
		line-height: 1.6;
		font-weight: 400;
		margin: 0px;
		}
	}

	.form_password-strength {
		margin-top: .5rem;
		.form_password-strength-indicator {
			grid-column-gap: .25rem;
			grid-row-gap: .25rem;
			justify-content: flex-start;
			align-items: center;
			display: flex;
		}
		.form_password-strength_line {
			background-color: #e2e8f0;
			flex: 1;
			height: .25rem;
		&.is-red {
			background-color: #d76b60;
		}
		&.is-yellow {
			background-color: #f5c60a;
		}
		&.is-green {
			background-color: #98bd47;
		}
		&.is-green2 {
			background-color: #47bd65;
		}
		}
		.form_password-strength-label {
			grid-column-gap: .25rem;
			grid-row-gap: .25rem;
			justify-content: flex-start;
			align-items: center;
			margin-top: .25rem;
			display: flex;
			.text-size-xsmall {
				font-size: 12px;
				line-height: 1.6;
				font-weight: 400;
				color: #334155;
				&.text-weight-semibold {
				font-weight: 600;
				}
			}
		}
	}

</style>
